export const fetchUnitList = async ({count, skip, search, sortReverse}) => {
  const url = "/service/unit";
  return (await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({count, skip, search, sortReverse})
  })).json();
};

export const fetchConsistHistoryOfUnit = async ({count, skip, sortType, sortReverse, unit}) => {
  const url = "/service/consist-history";
  return (await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      count, skip, sortType, sortReverse, unit
    })
  })).json();
};